export default [
  // This error comes from some terrible Norton browser extension. Nope.
  'Error calling method on NPObject.',

  // NFI. File "(unknown)" line (unknown) in [anonymous] -- not helpful
  'Script error.',

  // these errors indicate the user has flakey internet. We don't need to be told about that.
  'Bad request (Request has been terminated\nPossible causes: the network is offline, Origin is not allowed by Access-Control-Allow-Origin, the page is being unloaded, etc.)',
  'Request has been terminated\nPossible causes: the network is offline, Origin is not allowed by Access-Control-Allow-Origin, the page is being unloaded, etc. (Request has been terminated\nPossible causes: the network is offline, Origin is not allowed by Access-Control-Allow-Origin, the page is being unloaded, etc.)',
  'Request has been terminated\nPossible causes: the network is offline, Origin is not allowed by Access-Control-Allow-Origin, the page is being unloaded, etc.',
  'ServiceUnavailableError',

  // Firefox error, not helpful 'Exception... "<no message>" nsresult: "0x805e0006 (<unknown>)" location: "JS frame'
  // seems to be related to web sockets, happens only for some users, not able to reproduce: https://bugzilla.mozilla.org/show_bug.cgi?id=977020
  'NS_ERROR_NOT_CONNECTED',
  'NS_ERROR_UNEXPECTED',

  // Firefox issue, happens for some users. Most probable is caused by Firefox add-on's which try to
  // wrap/overwrite native functions like `eval`. No stack trace available.
  // https://support.mozilla.org/en-US/questions/963203
  // https://bugzilla.mozilla.org/show_bug.cgi?id=691059
  'Illegal operation on WrappedNative prototype object'
]
